import e from"@emotion/styled";const t=e.div`
  label: input-price-adornment;
  display: flex;
  position: relative;
  align-items: center;
  height: 100%;
`,i=e.div`
  label: input-price-button-wrapper;
  position: absolute;
  width: 26px;
  right: -26px;
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 8px;
  cursor: pointer;
`,r={display:"flex",alignItems:"center",height:"100%",paddingRight:"8px",borderWidth:0,borderRightWidth:"1px",borderStyle:"solid",borderColor:" rgb(242 245 246)"};export{t as InputPriceAdornmentStyled,i as InputPriceButtonWrapperStyled,r as TextStyles};
